module.exports = __webpack_public_path__ + "img/button-music-on.d463e319.svg";